@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-665_669_443)
internal val Res.string.labelledToggleSemanticToggle: StringResource by lazy {
      StringResource("string:labelledToggleSemanticToggle", "labelledToggleSemanticToggle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55416, 52),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23268, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25752, 44),
      ))
    }

@delegate:ResourceContentHash(-1_186_265_137)
internal val Res.string.language: StringResource by lazy {
      StringResource("string:language", "language", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55469, 32),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23313, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25797, 28),
      ))
    }

@delegate:ResourceContentHash(1_859_367_378)
internal val Res.string.localeSwapButton: StringResource by lazy {
      StringResource("string:localeSwapButton", "localeSwapButton", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55502, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23338, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25826, 40),
      ))
    }

@delegate:ResourceContentHash(1_076_804_594)
internal val Res.string.machuPicchu1438ce: StringResource by lazy {
      StringResource("string:machuPicchu1438ce", "machuPicchu1438ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55543, 313),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23375, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25867, 125),
      ))
    }

@delegate:ResourceContentHash(-1_398_502_808)
internal val Res.string.machuPicchu1572ce: StringResource by lazy {
      StringResource("string:machuPicchu1572ce", "machuPicchu1572ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55857, 445),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23501, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25993, 181),
      ))
    }

@delegate:ResourceContentHash(-1_745_008_712)
internal val Res.string.machuPicchu1867ce: StringResource by lazy {
      StringResource("string:machuPicchu1867ce", "machuPicchu1867ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 56303, 529),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23659, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26175, 201),
      ))
    }

@delegate:ResourceContentHash(-140_200_475)
internal val Res.string.machuPicchu1911ce: StringResource by lazy {
      StringResource("string:machuPicchu1911ce", "machuPicchu1911ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 56833, 717),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23845, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26377, 257),
      ))
    }

@delegate:ResourceContentHash(-550_396_926)
internal val Res.string.machuPicchu1964ce: StringResource by lazy {
      StringResource("string:machuPicchu1964ce", "machuPicchu1964ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 57551, 601),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24107, 249),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26635, 229),
      ))
    }

@delegate:ResourceContentHash(521_408_775)
internal val Res.string.machuPicchu1997ce: StringResource by lazy {
      StringResource("string:machuPicchu1997ce", "machuPicchu1997ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 58153, 473),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24357, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26865, 205),
      ))
    }

@delegate:ResourceContentHash(165_613_770)
internal val Res.string.machuPicchuArtifactCulture: StringResource by lazy {
      StringResource("string:machuPicchuArtifactCulture", "machuPicchuArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 58627, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24555, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27071, 42),
      ))
    }

@delegate:ResourceContentHash(1_781_633_215)
internal val Res.string.machuPicchuArtifactGeolocation: StringResource by lazy {
      StringResource("string:machuPicchuArtifactGeolocation", "machuPicchuArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 58678, 94),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24598, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27114, 58),
      ))
    }

@delegate:ResourceContentHash(-92_826_837)
internal val Res.string.machuPicchuCallout1: StringResource by lazy {
      StringResource("string:machuPicchuCallout1", "machuPicchuCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 58773, 583),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24649, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27173, 227),
      ))
    }

@delegate:ResourceContentHash(-664_855_979)
internal val Res.string.machuPicchuCallout2: StringResource by lazy {
      StringResource("string:machuPicchuCallout2", "machuPicchuCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 59357, 479),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 24853, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27401, 199),
      ))
    }

@delegate:ResourceContentHash(573_104_081)
internal val Res.string.machuPicchuCollectible1Icon: StringResource by lazy {
      StringResource("string:machuPicchuCollectible1Icon", "machuPicchuCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 59837, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25057, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27601, 47),
      ))
    }

@delegate:ResourceContentHash(257_548_585)
internal val Res.string.machuPicchuCollectible1Title: StringResource by lazy {
      StringResource("string:machuPicchuCollectible1Title", "machuPicchuCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 59893, 140),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25101, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27649, 68),
      ))
    }

@delegate:ResourceContentHash(-2_032_387_683)
internal val Res.string.machuPicchuCollectible2Icon: StringResource by lazy {
      StringResource("string:machuPicchuCollectible2Icon", "machuPicchuCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 60034, 59),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25166, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27718, 43),
      ))
    }

@delegate:ResourceContentHash(-1_469_837_508)
internal val Res.string.machuPicchuCollectible2Title: StringResource by lazy {
      StringResource("string:machuPicchuCollectible2Title", "machuPicchuCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 60094, 92),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25210, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27762, 60),
      ))
    }

@delegate:ResourceContentHash(24_172_908)
internal val Res.string.machuPicchuCollectible3Icon: StringResource by lazy {
      StringResource("string:machuPicchuCollectible3Icon", "machuPicchuCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 60187, 47),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25271, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27823, 43),
      ))
    }

@delegate:ResourceContentHash(-1_508_321_402)
internal val Res.string.machuPicchuCollectible3Title: StringResource by lazy {
      StringResource("string:machuPicchuCollectible3Title", "machuPicchuCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 60235, 68),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25315, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27867, 52),
      ))
    }

@delegate:ResourceContentHash(792_005_692)
internal val Res.string.machuPicchuConstructionInfo1: StringResource by lazy {
      StringResource("string:machuPicchuConstructionInfo1", "machuPicchuConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 60304, 1388),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25364, 412),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27920, 532),
      ))
    }

@delegate:ResourceContentHash(-382_963_004)
internal val Res.string.machuPicchuConstructionInfo2: StringResource by lazy {
      StringResource("string:machuPicchuConstructionInfo2", "machuPicchuConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 61693, 776),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 25777, 304),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28453, 344),
      ))
    }

@delegate:ResourceContentHash(1_449_625_273)
internal val Res.string.machuPicchuHistoryInfo1: StringResource by lazy {
      StringResource("string:machuPicchuHistoryInfo1", "machuPicchuHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 62470, 831),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 26082, 439),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28798, 407),
      ))
    }

@delegate:ResourceContentHash(-375_977_125)
internal val Res.string.machuPicchuHistoryInfo2: StringResource by lazy {
      StringResource("string:machuPicchuHistoryInfo2", "machuPicchuHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 63302, 1099),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 26522, 371),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29206, 447),
      ))
    }

@delegate:ResourceContentHash(1_090_653_609)
internal val Res.string.machuPicchuLocationInfo1: StringResource by lazy {
      StringResource("string:machuPicchuLocationInfo1", "machuPicchuLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 64402, 904),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 26894, 356),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29654, 432),
      ))
    }

@delegate:ResourceContentHash(2_025_136_705)
internal val Res.string.machuPicchuLocationInfo2: StringResource by lazy {
      StringResource("string:machuPicchuLocationInfo2", "machuPicchuLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 65307, 892),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27251, 308),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30087, 432),
      ))
    }

@delegate:ResourceContentHash(846_205_803)
internal val Res.string.machuPicchuMapCaption: StringResource by lazy {
      StringResource("string:machuPicchuMapCaption", "machuPicchuMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66200, 309),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27560, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30520, 137),
      ))
    }

@delegate:ResourceContentHash(2_040_947_186)
internal val Res.string.machuPicchuPullQuote1Author: StringResource by lazy {
      StringResource("string:machuPicchuPullQuote1Author", "machuPicchuPullQuote1Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66510, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27682, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30658, 55),
      ))
    }

@delegate:ResourceContentHash(-1_071_941_677)
internal val Res.string.machuPicchuPullQuote1Bottom: StringResource by lazy {
      StringResource("string:machuPicchuPullQuote1Bottom", "machuPicchuPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66590, 91),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27746, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30714, 71),
      ))
    }

@delegate:ResourceContentHash(-817_794_362)
internal val Res.string.machuPicchuPullQuote1Top: StringResource by lazy {
      StringResource("string:machuPicchuPullQuote1Top", "machuPicchuPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66682, 148),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27810, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30786, 72),
      ))
    }

@delegate:ResourceContentHash(1_615_024_981)
internal val Res.string.machuPicchuPullQuote2: StringResource by lazy {
      StringResource("string:machuPicchuPullQuote2", "machuPicchuPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66911, 425),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27939, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30915, 193),
      ))
    }

@delegate:ResourceContentHash(2_040_947_186)
internal val Res.string.machuPicchuPullQuote2Author: StringResource by lazy {
      StringResource("string:machuPicchuPullQuote2Author", "machuPicchuPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 66831, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 27875, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30859, 55),
      ))
    }

@delegate:ResourceContentHash(1_625_359_069)
internal val Res.string.machuPicchuRegionTitle: StringResource by lazy {
      StringResource("string:machuPicchuRegionTitle", "machuPicchuRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67337, 102),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28077, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31109, 54),
      ))
    }

@delegate:ResourceContentHash(1_435_927_414)
internal val Res.string.machuPicchuSubTitle: StringResource by lazy {
      StringResource("string:machuPicchuSubTitle", "machuPicchuSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67440, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28136, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31164, 55),
      ))
    }

@delegate:ResourceContentHash(1_081_293_605)
internal val Res.string.machuPicchuTitle: StringResource by lazy {
      StringResource("string:machuPicchuTitle", "machuPicchuTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67508, 60),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28180, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31220, 40),
      ))
    }

@delegate:ResourceContentHash(737_837_238)
internal val Res.string.machuPicchuVideoCaption: StringResource by lazy {
      StringResource("string:machuPicchuVideoCaption", "machuPicchuVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67569, 331),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28221, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31261, 147),
      ))
    }

@delegate:ResourceContentHash(-818_541_049)
internal val Res.string.newlyDiscoveredLabelNew: StringResource by lazy {
      StringResource("string:newlyDiscoveredLabelNew", "newlyDiscoveredLabelNew", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 67901, 119),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28349, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31409, 71),
      ))
    }

@delegate:ResourceContentHash(364_788_741)
internal val Res.string.newlyDiscoveredSemanticNew: StringResource by lazy {
      StringResource("string:newlyDiscoveredSemanticNew", "newlyDiscoveredSemanticNew", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68021, 206),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28417, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31481, 98),
      ))
    }

@delegate:ResourceContentHash(-1_243_923_002)
internal val Res.string.pageNotFoundBackButton: StringResource by lazy {
      StringResource("string:pageNotFoundBackButton", "pageNotFoundBackButton", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68228, 86),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28516, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31580, 58),
      ))
    }

@delegate:ResourceContentHash(-1_660_924_244)
internal val Res.string.pageNotFoundMessage: StringResource by lazy {
      StringResource("string:pageNotFoundMessage", "pageNotFoundMessage", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68315, 191),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28563, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31639, 87),
      ))
    }

@delegate:ResourceContentHash(-1_970_070_391)
internal val Res.string.petra106bce: StringResource by lazy {
      StringResource("string:petra106bce", "petra106bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68507, 143),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28635, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31727, 75),
      ))
    }

@delegate:ResourceContentHash(-1_439_996_784)
internal val Res.string.petra1200bce: StringResource by lazy {
      StringResource("string:petra1200bce", "petra1200bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68651, 268),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28719, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31803, 100),
      ))
    }

@delegate:ResourceContentHash(731_147_811)
internal val Res.string.petra1812ce: StringResource by lazy {
      StringResource("string:petra1812ce", "petra1812ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 68920, 227),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28792, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31904, 99),
      ))
    }

@delegate:ResourceContentHash(-796_461_494)
internal val Res.string.petra1958ce: StringResource by lazy {
      StringResource("string:petra1958ce", "petra1958ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 69148, 343),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 28916, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32004, 167),
      ))
    }

@delegate:ResourceContentHash(-1_926_771_908)
internal val Res.string.petra1989ce: StringResource by lazy {
      StringResource("string:petra1989ce", "petra1989ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 69492, 207),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29064, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32172, 95),
      ))
    }

@delegate:ResourceContentHash(1_995_109_761)
internal val Res.string.petra551ce: StringResource by lazy {
      StringResource("string:petra551ce", "petra551ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 69700, 258),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29168, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32268, 118),
      ))
    }

@delegate:ResourceContentHash(-2_036_548_291)
internal val Res.string.petraArtifactCulture: StringResource by lazy {
      StringResource("string:petraArtifactCulture", "petraArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 69959, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29259, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32387, 40),
      ))
    }

@delegate:ResourceContentHash(-125_402_285)
internal val Res.string.petraArtifactGeolocation: StringResource by lazy {
      StringResource("string:petraArtifactGeolocation", "petraArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70016, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29300, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32428, 40),
      ))
    }

@delegate:ResourceContentHash(-1_147_491_471)
internal val Res.string.petraCallout1: StringResource by lazy {
      StringResource("string:petraCallout1", "petraCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70073, 257),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29345, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32469, 137),
      ))
    }

@delegate:ResourceContentHash(-1_919_706_311)
internal val Res.string.petraCallout2: StringResource by lazy {
      StringResource("string:petraCallout2", "petraCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70331, 321),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29435, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32607, 145),
      ))
    }

@delegate:ResourceContentHash(-2_032_387_683)
internal val Res.string.petraCollectible1Icon: StringResource by lazy {
      StringResource("string:petraCollectible1Icon", "petraCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70653, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29533, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32753, 37),
      ))
    }

@delegate:ResourceContentHash(-1_123_940_429)
internal val Res.string.petraCollectible1Title: StringResource by lazy {
      StringResource("string:petraCollectible1Title", "petraCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70707, 70),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29571, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32791, 54),
      ))
    }

@delegate:ResourceContentHash(-177_868_442)
internal val Res.string.petraCollectible2Icon: StringResource by lazy {
      StringResource("string:petraCollectible2Icon", "petraCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70778, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29630, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32846, 37),
      ))
    }

@delegate:ResourceContentHash(-2_053_688_962)
internal val Res.string.petraCollectible2Title: StringResource by lazy {
      StringResource("string:petraCollectible2Title", "petraCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70820, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29664, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32884, 38),
      ))
    }

@delegate:ResourceContentHash(-177_868_442)
internal val Res.string.petraCollectible3Icon: StringResource by lazy {
      StringResource("string:petraCollectible3Icon", "petraCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70871, 41),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29703, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32923, 37),
      ))
    }

@delegate:ResourceContentHash(-760_217_146)
internal val Res.string.petraCollectible3Title: StringResource by lazy {
      StringResource("string:petraCollectible3Title", "petraCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70913, 70),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29737, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32961, 42),
      ))
    }

@delegate:ResourceContentHash(609_177_984)
internal val Res.string.petraConstructionInfo1: StringResource by lazy {
      StringResource("string:petraConstructionInfo1", "petraConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 70984, 1274),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 29772, 370),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33004, 530),
      ))
    }

@delegate:ResourceContentHash(-1_993_689_952)
internal val Res.string.petraConstructionInfo2: StringResource by lazy {
      StringResource("string:petraConstructionInfo2", "petraConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 72259, 1822),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 30143, 662),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33535, 746),
      ))
    }

@delegate:ResourceContentHash(623_130_290)
internal val Res.string.petraHistoryInfo1: StringResource by lazy {
      StringResource("string:petraHistoryInfo1", "petraHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 74082, 1409),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 30806, 517),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34282, 657),
      ))
    }

@delegate:ResourceContentHash(-770_398_810)
internal val Res.string.petraHistoryInfo2: StringResource by lazy {
      StringResource("string:petraHistoryInfo2", "petraHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 75492, 1081),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 31324, 449),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34940, 465),
      ))
    }

@delegate:ResourceContentHash(165_508_804)
internal val Res.string.petraLocationInfo1: StringResource by lazy {
      StringResource("string:petraLocationInfo1", "petraLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 76574, 650),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 31774, 242),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35406, 318),
      ))
    }

@delegate:ResourceContentHash(1_523_720_721)
internal val Res.string.petraLocationInfo2: StringResource by lazy {
      StringResource("string:petraLocationInfo2", "petraLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 77225, 1526),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32017, 554),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35725, 686),
      ))
    }

@delegate:ResourceContentHash(-352_132_938)
internal val Res.string.petraMapCaption: StringResource by lazy {
      StringResource("string:petraMapCaption", "petraMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 78752, 247),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32572, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36412, 107),
      ))
    }

@delegate:ResourceContentHash(11_167_372)
internal val Res.string.petraPullQuote1Author: StringResource by lazy {
      StringResource("string:petraPullQuote1Author", "petraPullQuote1Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79000, 89),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32660, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36520, 57),
      ))
    }

@delegate:ResourceContentHash(-801_968_716)
internal val Res.string.petraPullQuote1Bottom: StringResource by lazy {
      StringResource("string:petraPullQuote1Bottom", "petraPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79090, 101),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32722, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36578, 57),
      ))
    }

@delegate:ResourceContentHash(-274_891_112)
internal val Res.string.petraPullQuote1Top: StringResource by lazy {
      StringResource("string:petraPullQuote1Top", "petraPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79192, 82),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32796, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36636, 46),
      ))
    }

@delegate:ResourceContentHash(-1_239_129_755)
internal val Res.string.petraPullQuote2: StringResource by lazy {
      StringResource("string:petraPullQuote2", "petraPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79349, 435),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32909, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36733, 151),
      ))
    }

@delegate:ResourceContentHash(1_417_734_051)
internal val Res.string.petraPullQuote2Author: StringResource by lazy {
      StringResource("string:petraPullQuote2Author", "petraPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79275, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 32855, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36683, 49),
      ))
    }

@delegate:ResourceContentHash(-306_912_569)
internal val Res.string.petraRegionTitle: StringResource by lazy {
      StringResource("string:petraRegionTitle", "petraRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79785, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33029, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36885, 44),
      ))
    }

@delegate:ResourceContentHash(-673_683_986)
internal val Res.string.petraSubTitle: StringResource by lazy {
      StringResource("string:petraSubTitle", "petraSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79850, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33074, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36930, 41),
      ))
    }

@delegate:ResourceContentHash(479_096_354)
internal val Res.string.petraTitle: StringResource by lazy {
      StringResource("string:petraTitle", "petraTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79916, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33116, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36972, 26),
      ))
    }

@delegate:ResourceContentHash(-294_825_000)
internal val Res.string.petraVideoCaption: StringResource by lazy {
      StringResource("string:petraVideoCaption", "petraVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 79959, 393),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33147, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36999, 165),
      ))
    }

@delegate:ResourceContentHash(493_509_113)
internal val Res.string.photoGallerySemanticCollectible: StringResource by lazy {
      StringResource("string:photoGallerySemanticCollectible", "photoGallerySemanticCollectible", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 80353, 79),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33281, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37165, 55),
      ))
    }

@delegate:ResourceContentHash(1_048_312_602)
internal val Res.string.photoGallerySemanticFocus: StringResource by lazy {
      StringResource("string:photoGallerySemanticFocus", "photoGallerySemanticFocus", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 80433, 169),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33337, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37221, 77),
      ))
    }

@delegate:ResourceContentHash(1_661_023_812)
internal val Res.string.photoGallerySemanticFullscreen: StringResource by lazy {
      StringResource("string:photoGallerySemanticFullscreen", "photoGallerySemanticFullscreen", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 80603, 218),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33439, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37299, 102),
      ))
    }

@delegate:ResourceContentHash(154_294_318)
internal val Res.string.privacyPolicy: StringResource by lazy {
      StringResource("string:privacyPolicy", "privacyPolicy", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 80822, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33566, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37402, 41),
      ))
    }

@delegate:ResourceContentHash(-59_391_765)
internal val Res.string.privacyStatement: StringResource by lazy {
      StringResource("string:privacyStatement", "privacyStatement", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 80896, 312),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33604, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37444, 116),
      ))
    }

@delegate:ResourceContentHash(-24_708_535)
internal val Res.string.pyramidsGiza1925ce: StringResource by lazy {
      StringResource("string:pyramidsGiza1925ce", "pyramidsGiza1925ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 81209, 522),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 33781, 230),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37561, 250),
      ))
    }

@delegate:ResourceContentHash(-1_077_781_472)
internal val Res.string.pyramidsGiza1979ce: StringResource by lazy {
      StringResource("string:pyramidsGiza1979ce", "pyramidsGiza1979ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 81732, 378),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34012, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37812, 158),
      ))
    }

@delegate:ResourceContentHash(1_129_953_879)
internal val Res.string.pyramidsGiza1990ce: StringResource by lazy {
      StringResource("string:pyramidsGiza1990ce", "pyramidsGiza1990ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 82111, 798),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34191, 246),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37971, 314),
      ))
    }

@delegate:ResourceContentHash(895_646_875)
internal val Res.string.pyramidsGiza2465bce: StringResource by lazy {
      StringResource("string:pyramidsGiza2465bce", "pyramidsGiza2465bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 82910, 431),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34438, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38286, 179),
      ))
    }

@delegate:ResourceContentHash(106_989_553)
internal val Res.string.pyramidsGiza2575bce: StringResource by lazy {
      StringResource("string:pyramidsGiza2575bce", "pyramidsGiza2575bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 83342, 351),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34610, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38466, 163),
      ))
    }

@delegate:ResourceContentHash(-1_961_367_610)
internal val Res.string.pyramidsGiza443bce: StringResource by lazy {
      StringResource("string:pyramidsGiza443bce", "pyramidsGiza443bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 83694, 606),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34770, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38630, 250),
      ))
    }

@delegate:ResourceContentHash(1_453_696_780)
internal val Res.string.pyramidsGizaArtifactCulture: StringResource by lazy {
      StringResource("string:pyramidsGizaArtifactCulture", "pyramidsGizaArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 84301, 59),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 34989, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38881, 47),
      ))
    }

@delegate:ResourceContentHash(581_547_058)
internal val Res.string.pyramidsGizaArtifactGeolocation: StringResource by lazy {
      StringResource("string:pyramidsGizaArtifactGeolocation", "pyramidsGizaArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 84361, 59),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35033, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38929, 47),
      ))
    }

@delegate:ResourceContentHash(-196_424_878)
internal val Res.string.pyramidsGizaCallout1: StringResource by lazy {
      StringResource("string:pyramidsGizaCallout1", "pyramidsGizaCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 84421, 656),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35081, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38977, 224),
      ))
    }

@delegate:ResourceContentHash(-1_711_699_566)
internal val Res.string.pyramidsGizaCallout2: StringResource by lazy {
      StringResource("string:pyramidsGizaCallout2", "pyramidsGizaCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85078, 520),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35214, 200),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39202, 288),
      ))
    }

@delegate:ResourceContentHash(588_971_644)
internal val Res.string.pyramidsGizaCollectible1Icon: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible1Icon", "pyramidsGizaCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85599, 64),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35415, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39491, 44),
      ))
    }

@delegate:ResourceContentHash(35_753_860)
internal val Res.string.pyramidsGizaCollectible1Title: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible1Title", "pyramidsGizaCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85664, 93),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35460, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39536, 65),
      ))
    }

@delegate:ResourceContentHash(-2_032_387_683)
internal val Res.string.pyramidsGizaCollectible2Icon: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible2Icon", "pyramidsGizaCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85758, 60),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35518, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39602, 44),
      ))
    }

@delegate:ResourceContentHash(-71_129_534)
internal val Res.string.pyramidsGizaCollectible2Title: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible2Title", "pyramidsGizaCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85819, 133),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35563, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39647, 81),
      ))
    }

@delegate:ResourceContentHash(700_969_513)
internal val Res.string.pyramidsGizaCollectible3Icon: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible3Icon", "pyramidsGizaCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 85953, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35649, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39729, 48),
      ))
    }

@delegate:ResourceContentHash(-403_220_686)
internal val Res.string.pyramidsGizaCollectible3Title: StringResource by lazy {
      StringResource("string:pyramidsGizaCollectible3Title", "pyramidsGizaCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 86010, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35694, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39778, 61),
      ))
    }

@delegate:ResourceContentHash(1_199_266_705)
internal val Res.string.pyramidsGizaConstructionInfo1: StringResource by lazy {
      StringResource("string:pyramidsGizaConstructionInfo1", "pyramidsGizaConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 86088, 1801),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 35740, 681),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39840, 725),
      ))
    }

@delegate:ResourceContentHash(1_699_912_775)
internal val Res.string.pyramidsGizaConstructionInfo2: StringResource by lazy {
      StringResource("string:pyramidsGizaConstructionInfo2", "pyramidsGizaConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 87890, 2093),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 36422, 741),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40566, 885),
      ))
    }

@delegate:ResourceContentHash(375_742_575)
internal val Res.string.pyramidsGizaHistoryInfo1: StringResource by lazy {
      StringResource("string:pyramidsGizaHistoryInfo1", "pyramidsGizaHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 89984, 1256),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 37164, 460),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41452, 552),
      ))
    }

@delegate:ResourceContentHash(1_543_294_257)
internal val Res.string.pyramidsGizaHistoryInfo2: StringResource by lazy {
      StringResource("string:pyramidsGizaHistoryInfo2", "pyramidsGizaHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 91241, 1088),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 37625, 416),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42005, 504),
      ))
    }

@delegate:ResourceContentHash(-1_207_705_940)
internal val Res.string.pyramidsGizaLocationInfo1: StringResource by lazy {
      StringResource("string:pyramidsGizaLocationInfo1", "pyramidsGizaLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 92330, 673),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38042, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42510, 285),
      ))
    }

@delegate:ResourceContentHash(1_582_442_816)
internal val Res.string.pyramidsGizaLocationInfo2: StringResource by lazy {
      StringResource("string:pyramidsGizaLocationInfo2", "pyramidsGizaLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 93004, 657),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38276, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42796, 293),
      ))
    }

@delegate:ResourceContentHash(475_974_222)
internal val Res.string.pyramidsGizaMapCaption: StringResource by lazy {
      StringResource("string:pyramidsGizaMapCaption", "pyramidsGizaMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 93662, 278),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38478, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43090, 114),
      ))
    }

@delegate:ResourceContentHash(-1_432_959_601)
internal val Res.string.pyramidsGizaPullQuote1Bottom: StringResource by lazy {
      StringResource("string:pyramidsGizaPullQuote1Bottom", "pyramidsGizaPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 93941, 160),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 38589, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43205, 88),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("labelledToggleSemanticToggle", Res.string.labelledToggleSemanticToggle)
  map.put("language", Res.string.language)
  map.put("localeSwapButton", Res.string.localeSwapButton)
  map.put("machuPicchu1438ce", Res.string.machuPicchu1438ce)
  map.put("machuPicchu1572ce", Res.string.machuPicchu1572ce)
  map.put("machuPicchu1867ce", Res.string.machuPicchu1867ce)
  map.put("machuPicchu1911ce", Res.string.machuPicchu1911ce)
  map.put("machuPicchu1964ce", Res.string.machuPicchu1964ce)
  map.put("machuPicchu1997ce", Res.string.machuPicchu1997ce)
  map.put("machuPicchuArtifactCulture", Res.string.machuPicchuArtifactCulture)
  map.put("machuPicchuArtifactGeolocation", Res.string.machuPicchuArtifactGeolocation)
  map.put("machuPicchuCallout1", Res.string.machuPicchuCallout1)
  map.put("machuPicchuCallout2", Res.string.machuPicchuCallout2)
  map.put("machuPicchuCollectible1Icon", Res.string.machuPicchuCollectible1Icon)
  map.put("machuPicchuCollectible1Title", Res.string.machuPicchuCollectible1Title)
  map.put("machuPicchuCollectible2Icon", Res.string.machuPicchuCollectible2Icon)
  map.put("machuPicchuCollectible2Title", Res.string.machuPicchuCollectible2Title)
  map.put("machuPicchuCollectible3Icon", Res.string.machuPicchuCollectible3Icon)
  map.put("machuPicchuCollectible3Title", Res.string.machuPicchuCollectible3Title)
  map.put("machuPicchuConstructionInfo1", Res.string.machuPicchuConstructionInfo1)
  map.put("machuPicchuConstructionInfo2", Res.string.machuPicchuConstructionInfo2)
  map.put("machuPicchuHistoryInfo1", Res.string.machuPicchuHistoryInfo1)
  map.put("machuPicchuHistoryInfo2", Res.string.machuPicchuHistoryInfo2)
  map.put("machuPicchuLocationInfo1", Res.string.machuPicchuLocationInfo1)
  map.put("machuPicchuLocationInfo2", Res.string.machuPicchuLocationInfo2)
  map.put("machuPicchuMapCaption", Res.string.machuPicchuMapCaption)
  map.put("machuPicchuPullQuote1Author", Res.string.machuPicchuPullQuote1Author)
  map.put("machuPicchuPullQuote1Bottom", Res.string.machuPicchuPullQuote1Bottom)
  map.put("machuPicchuPullQuote1Top", Res.string.machuPicchuPullQuote1Top)
  map.put("machuPicchuPullQuote2", Res.string.machuPicchuPullQuote2)
  map.put("machuPicchuPullQuote2Author", Res.string.machuPicchuPullQuote2Author)
  map.put("machuPicchuRegionTitle", Res.string.machuPicchuRegionTitle)
  map.put("machuPicchuSubTitle", Res.string.machuPicchuSubTitle)
  map.put("machuPicchuTitle", Res.string.machuPicchuTitle)
  map.put("machuPicchuVideoCaption", Res.string.machuPicchuVideoCaption)
  map.put("newlyDiscoveredLabelNew", Res.string.newlyDiscoveredLabelNew)
  map.put("newlyDiscoveredSemanticNew", Res.string.newlyDiscoveredSemanticNew)
  map.put("pageNotFoundBackButton", Res.string.pageNotFoundBackButton)
  map.put("pageNotFoundMessage", Res.string.pageNotFoundMessage)
  map.put("petra106bce", Res.string.petra106bce)
  map.put("petra1200bce", Res.string.petra1200bce)
  map.put("petra1812ce", Res.string.petra1812ce)
  map.put("petra1958ce", Res.string.petra1958ce)
  map.put("petra1989ce", Res.string.petra1989ce)
  map.put("petra551ce", Res.string.petra551ce)
  map.put("petraArtifactCulture", Res.string.petraArtifactCulture)
  map.put("petraArtifactGeolocation", Res.string.petraArtifactGeolocation)
  map.put("petraCallout1", Res.string.petraCallout1)
  map.put("petraCallout2", Res.string.petraCallout2)
  map.put("petraCollectible1Icon", Res.string.petraCollectible1Icon)
  map.put("petraCollectible1Title", Res.string.petraCollectible1Title)
  map.put("petraCollectible2Icon", Res.string.petraCollectible2Icon)
  map.put("petraCollectible2Title", Res.string.petraCollectible2Title)
  map.put("petraCollectible3Icon", Res.string.petraCollectible3Icon)
  map.put("petraCollectible3Title", Res.string.petraCollectible3Title)
  map.put("petraConstructionInfo1", Res.string.petraConstructionInfo1)
  map.put("petraConstructionInfo2", Res.string.petraConstructionInfo2)
  map.put("petraHistoryInfo1", Res.string.petraHistoryInfo1)
  map.put("petraHistoryInfo2", Res.string.petraHistoryInfo2)
  map.put("petraLocationInfo1", Res.string.petraLocationInfo1)
  map.put("petraLocationInfo2", Res.string.petraLocationInfo2)
  map.put("petraMapCaption", Res.string.petraMapCaption)
  map.put("petraPullQuote1Author", Res.string.petraPullQuote1Author)
  map.put("petraPullQuote1Bottom", Res.string.petraPullQuote1Bottom)
  map.put("petraPullQuote1Top", Res.string.petraPullQuote1Top)
  map.put("petraPullQuote2", Res.string.petraPullQuote2)
  map.put("petraPullQuote2Author", Res.string.petraPullQuote2Author)
  map.put("petraRegionTitle", Res.string.petraRegionTitle)
  map.put("petraSubTitle", Res.string.petraSubTitle)
  map.put("petraTitle", Res.string.petraTitle)
  map.put("petraVideoCaption", Res.string.petraVideoCaption)
  map.put("photoGallerySemanticCollectible", Res.string.photoGallerySemanticCollectible)
  map.put("photoGallerySemanticFocus", Res.string.photoGallerySemanticFocus)
  map.put("photoGallerySemanticFullscreen", Res.string.photoGallerySemanticFullscreen)
  map.put("privacyPolicy", Res.string.privacyPolicy)
  map.put("privacyStatement", Res.string.privacyStatement)
  map.put("pyramidsGiza1925ce", Res.string.pyramidsGiza1925ce)
  map.put("pyramidsGiza1979ce", Res.string.pyramidsGiza1979ce)
  map.put("pyramidsGiza1990ce", Res.string.pyramidsGiza1990ce)
  map.put("pyramidsGiza2465bce", Res.string.pyramidsGiza2465bce)
  map.put("pyramidsGiza2575bce", Res.string.pyramidsGiza2575bce)
  map.put("pyramidsGiza443bce", Res.string.pyramidsGiza443bce)
  map.put("pyramidsGizaArtifactCulture", Res.string.pyramidsGizaArtifactCulture)
  map.put("pyramidsGizaArtifactGeolocation", Res.string.pyramidsGizaArtifactGeolocation)
  map.put("pyramidsGizaCallout1", Res.string.pyramidsGizaCallout1)
  map.put("pyramidsGizaCallout2", Res.string.pyramidsGizaCallout2)
  map.put("pyramidsGizaCollectible1Icon", Res.string.pyramidsGizaCollectible1Icon)
  map.put("pyramidsGizaCollectible1Title", Res.string.pyramidsGizaCollectible1Title)
  map.put("pyramidsGizaCollectible2Icon", Res.string.pyramidsGizaCollectible2Icon)
  map.put("pyramidsGizaCollectible2Title", Res.string.pyramidsGizaCollectible2Title)
  map.put("pyramidsGizaCollectible3Icon", Res.string.pyramidsGizaCollectible3Icon)
  map.put("pyramidsGizaCollectible3Title", Res.string.pyramidsGizaCollectible3Title)
  map.put("pyramidsGizaConstructionInfo1", Res.string.pyramidsGizaConstructionInfo1)
  map.put("pyramidsGizaConstructionInfo2", Res.string.pyramidsGizaConstructionInfo2)
  map.put("pyramidsGizaHistoryInfo1", Res.string.pyramidsGizaHistoryInfo1)
  map.put("pyramidsGizaHistoryInfo2", Res.string.pyramidsGizaHistoryInfo2)
  map.put("pyramidsGizaLocationInfo1", Res.string.pyramidsGizaLocationInfo1)
  map.put("pyramidsGizaLocationInfo2", Res.string.pyramidsGizaLocationInfo2)
  map.put("pyramidsGizaMapCaption", Res.string.pyramidsGizaMapCaption)
  map.put("pyramidsGizaPullQuote1Bottom", Res.string.pyramidsGizaPullQuote1Bottom)
}
